// Charcoal Professional design
const CharcoalProfessionalDesign = {
  id: 'charcoal-professional',
  name: 'Charcoal',
  category: 'professional',
  description: 'Strong charcoal and grey tones for a serious look',
  colors: {
    primary: "#343a40",    // Dark Charcoal
    secondary: "#6c757d",  // Medium Grey
    tertiary: "#adb5bd",   // Light Grey
    quaternary: "#dee2e6", // Very Light Grey
    accent1: "#343a40",    // Dark Charcoal
    accent2: "#6c757d",    // Medium Grey
    // Add other accents if needed
    text: "#212529",       // Near Black Text
    textSecondary: "#6c757d", // Medium Grey Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#f8f9fa", // Very Light Grey sidebar
    border: "#ffffff"     // Light Grey border
  },
};

export default CharcoalProfessionalDesign; 